import axios from "axios"

export default async function validateForm(projectName, formName){
    await axios.post(`/project/${projectName}/${formName}/validate`);
}